import { render, staticRenderFns } from "./RegionMap.vue?vue&type=template&id=fadad2de&scoped=true&"
import script from "./RegionMap.vue?vue&type=script&lang=js&"
export * from "./RegionMap.vue?vue&type=script&lang=js&"
import style0 from "./RegionMap.vue?vue&type=style&index=0&id=fadad2de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fadad2de",
  null
  
)

export default component.exports